import { decryptUser } from './user'

type trackingType =
  | 'begin_checkout'
  | 'kyc_video_submitted'
  | 'kyc_video_with_id_submitted'
  | 'login_form_open'
  | 'logout'
  | 'open_game'
  | 'registration_form_init'
  | 'registration_success'
  | 'user_login'

const sendEventToNativeApp = (
  type: trackingType,
  payload: Record<string, unknown> = {},
) => {
  const user = decryptUser()
  const event = {
    type,
    payload: {
      ...payload,
      username: user?.username || '',
    },
  }

  window?.flutter_inappwebview?.callHandler('adjustEvent', event)

  window?.jsBridge?.postMessage(type, JSON.stringify(event.payload))
}

const setAdvertisingId = () => {
  const params = new URLSearchParams(window.location.search)
  const adId = params.get('ad_id')
  const platform = params.get('platform') as 'android' | 'ios'

  // If adId or platform is not found, return
  if (!adId || !platform) return

  localStorage.setItem('advertising_id', adId)
  localStorage.setItem('advertising_platform', platform)
}

const getAdvertisingId = () => {
  const advertisingId = localStorage.getItem('advertising_id')
  const platform = localStorage.getItem('advertising_platform')

  if (!advertisingId || !platform) return {}

  if (platform === 'android') {
    return {
      gps_adid: advertisingId,
    }
  } else if (platform === 'ios') {
    return {
      idfa: advertisingId,
    }
  }
}

const getReportSdkData = (): Record<string, unknown> | null => {
  const raw = window?.jsBridge?.getReportSdkData?.()
  if (!raw) return null
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) as Record<string, unknown>
    } catch {
      return null
    }
  }
  return raw
}

export default sendEventToNativeApp
export { getAdvertisingId, getReportSdkData, setAdvertisingId }
